import React, { useState, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import styles from './Home.module.scss';
import loginImg from '../../static/login/logo.png';
import loginImg2 from '../../static/login/logo2.png';
import phoneImg from '../../static/home/phone.png';
import erImg from '../../static/home/er.png';
import erweiImgs from '../../static/home/erwei.jpg';
import emailImg from '../../static/home/emial.png';
import homeImgsBj from '../../static/home/homebj.png';
import AuthenticationQuery from '../AuthenticationQuery';
import ListOfCertifiedEnterprises from '../ListOfCertifiedEnterprises/index';
import BottomPage from '../Bottom/index'
import { Popconfirm } from 'antd'; // 引入 Popconfirm 组件
import CertificationList from '../CertificationList/index'
import { useLocation } from 'react-router-dom';
// import ListOfCompanies from '../ListOfCompanies/index'
// 导航项组件
const NavItem = ({ label, active, onClick }) => (
  <div
    className={clsx(styles.navItem, { [styles.active]: active })}
    onClick={onClick}
  >
    {label}
    {active && <div className={styles.underline}></div>}
  </div>
);

// 图片组件
const ImageItem = ({ src, alt, onMouseEnter, onMouseLeave }) => (
  <img
    className={clsx(styles.rightImgsLogin)}
    src={src}
    alt={alt}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  />
);

// Popconfirm
const popconfirmContent = {
  phone: (
    <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>联系电话</div>
      <div style={{ textAlign: 'center', fontWeight: 'bold' }}>87108881-454</div>
    </div>
  ),
  qr: (
    <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>联系微信</div>
      <div><img src={erweiImgs} style={{ width: '150px', height: '150px' }} alt="" /></div>
    </div>
  ),
  email: (
    <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>企业联系邮箱</div>
      <div style={{ textAlign: 'center', fontWeight: 'bold' }}>csc@csgf.org.cn</div>
    </div>
  ),
};

const items = [
  { key: '1', label: '认证查询' },
  { key: '2', label: '获证企业名录' },
];

const Home = () => {
  const location = useLocation();
  const [listIsShow, setListIsShow] = useState(false);
  const [activeKey, setActiveKey] = useState('1');
  const [visible, setVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
 // 用来接收子组件的导航选中值
  const [currentNavKey, setCurrentNavKey] = useState(1);
    // 接收子组件传过来的 activeKey
  const handleNavChange = (value) => {
    console.log("父组件收到当前选中导航：", value);
    
    setCurrentNavKey(value);
  };
  const handleItemClick = useCallback((key) => {
    setCurrentNavKey(1);
    setActiveKey(key);
     
    setListIsShow(false);
  }, []);

  // 显示 Popconfirm 的逻辑
  const handleMouseEnter = (image) => {
    setCurrentImage(image);
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
    setCurrentImage(null);
  };
  const [dataFromAuthQuery, setDataFromAuthQuery] = useState(null);


  // 这个回调函数用于接收来自 AuthenticationQuery 的数据
  const handleDataFromAuthenticationQuery = (data) => {
    setDataFromAuthQuery(data);  // 将接收到的数据保存在父组件的 
    setListIsShow(true); // 切换到展示认证企业名录
  };
  // 在组件加载时检查 URL 中的 activeKey 参数
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const activeKeyFromUrl = queryParams.get('activeKey');
    if (activeKeyFromUrl) {
      setActiveKey(activeKeyFromUrl); // 如果传递了 activeKey，更新状态
    }
  }, [location.search]);

  return (
    <div className={styles.homeClass}>
      <div className={styles.topClass}>
        <div className={styles.homeTop}>
          {/* 左侧logo */}
            { currentNavKey!== 4 && (
            <img className={styles.logotopImgs} src={loginImg} alt="Logo" />
          )}
          {currentNavKey === 4 && (
            <img className={styles.logotopImgs} src={loginImg2} alt="Logo" />
          )}
          {/* 头部导航 */}
          <nav className={styles.nav}>
            {items.map(item => (
              <NavItem
                key={item.key}
                label={item.label}
                active={activeKey === item.key}
                onClick={() => handleItemClick(item.key)}
              />
            ))}
          </nav>
          {/* 右侧图片 */}
          <div className={styles.rightImgs}>
            {['phone', 'qr', 'email'].map((image) => (
              <Popconfirm
                key={image}
                title={popconfirmContent[image]} // 使用映射的内容
                open={visible && currentImage === image} // 控制 Popconfirm 是否显示
                onCancel={handleMouseLeave} // 取消操作时隐藏 Popconfirm
                onConfirm={handleMouseLeave} // 点击确认时隐藏 Popconfirm
                okButtonProps={{ style: { display: 'none' } }} // 隐藏 "确认" 按钮
                cancelButtonProps={{ style: { display: 'none' } }} // 隐藏 "取消" 按钮
                onVisibleChange={(newVisible) => {
                  if (!newVisible) {
                    setVisible(false); // 关闭时隐藏 Popconfirm
                  }
                }}
                icon={null}
              >
                <ImageItem
                  src={image === 'phone' ? phoneImg : image === 'qr' ? erImg : emailImg}
                  alt={image}
                  onMouseEnter={() => handleMouseEnter(image)} // 鼠标移入时触发
                  onMouseLeave={handleMouseLeave} // 鼠标移出时触发
                />
              </Popconfirm>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.homeImgs}>
        <img className={styles.homeImgsBjclass} src={homeImgsBj} alt="Home background" />
      </div>
      <div className={styles.homeContents}>
        {activeKey === '1' && !listIsShow && <AuthenticationQuery  onNavChange={handleNavChange} onDataSubmit={handleDataFromAuthenticationQuery} />}
        {activeKey === '2' && !listIsShow && <ListOfCertifiedEnterprises ListOfCertifiedEnterprisesdata={handleDataFromAuthenticationQuery} />}
        {listIsShow && activeKey === '1' && <CertificationList filterData={dataFromAuthQuery} />}
      </div>
      <BottomPage></BottomPage>
    </div>
  );
};

export default Home;
